export default {
  'acc102.cashProjection': '预计现金余额',
  'acc102.cashTaxIncluded': '含税现金余额',
  'acc102.cashTaxExcluded': '不含税现金余额',
  'acc102.cashReceivable': '预计売掛金（含税）',
  'acc102.cashTaxReserve': '消费税预留（概算）',
  'acc102.cashKnown': '已知现金余额',
  'acc102.cashBaseline': '基准月末余额',
  'acc102.cashRange': '推算期间',
  'acc102.cashOpening': '期初现金余额',
  'acc102.cashMovement': '期间收支变动',
  'acc102.cashClosing': '期末现金余额',
  'acc102.cashProjectionNotice':
    '含税现金从2026年9月底3400万起，按发票付款期限预计到账；无期限按业务所属月后2个月。未到预计到账月的金额列为売掛金，不提前加到现金。税金按业务所属月预留（含未回款部分），不含税现金＝含税现金－2026年1月起累计税金预留。不抵扣进项税或已缴税，不拆分手工金额。仅为经营概算，非应纳税额或实际到账记录；基准前不反推。',
  'acc102.cashBeforeBaseline': '该期间早于已知基准，不反推现金余额。',
  'acc102.cashOutOfRange': '超出预计现金余额的推算范围，请选择较近期间。',
  'acc102.cashIncomplete': '存在成本待核对月份，之后余额暂无法确定',
  'acc102.fixedExpenses': '固定支出',
  'acc102.fixedExpensesNotice':
    '2026年每个月按设定金额计入，非实际付款记录；不自动延续至其他年份。请勿手工重复登记。',
  'acc102.fixedExpenseAmount': '每月固定金额',
  'acc102.fixed.UR': 'UR',
  'acc102.fixed.UTILITIES': '光热水电垃圾',
  'acc102.fixed.REPAYMENT_1': '还款1',
  'acc102.fixed.WITHHOLDING_TAX': '个人源泉所得税',
  'acc102.fixed.LOCAL_TAX': '地方税',
  'acc102.fixed.OFFICE': '事务所',
  'acc102.fixed.AWS': 'AWS',
  'acc102.fixed.TEAMS': 'Teams',
  'acc102.fixed.CODEX': 'Codex',
  'acc102.fixedFxNotice':
    '预算换算：{currency} {amount} × {rate} JPY/{currency}；参考日：{date}。四舍五入至日元，非实际扣款，不额外加税或手续费，不自动重算历史汇率。',
  'acc102.estimated': '（预计）',
  'acc102.referenceMonth': '参考月份',
  'acc102.invoiceAuto': '发票收入（不含税）',
  'acc102.invoiceAutoNotice':
    '采用营业部发票一览的不含税金额，按所属月份计入，包含未开票预计；不改变原发票或收款，收款记录不重复计入。请勿手工重复登记。',
  'acc102.commuteAuto': '交通费',
  'acc102.commuteAutoNotice':
    '按所属月份计入全部通勤费申请（含未提交、待审批、已批准及退回）。仅整月没有申请时，采用最近已结束且早于目标月的有数据月份，标注预计及参考月；已有申请不补齐。请勿手工重复登记。',
  'acc102.companyId': '公司ID',
  'acc102.applications': '申请笔数',
  'acc102.invoiceForecastAmount': '不含税金额（含预计）',
  'acc102.commuteAmount': '申请金额',
  'acc102.manualStatus': '手工项目状态',
  'acc102.salaryPeriodTotal': '本查询期间已登记实付金额',
  'menu.accounting.income-expense': '损益对照',
  'acc102.pageTitle': '损益对照',
  'acc102.INCOME': '收入',
  'acc102.EXPENSE': '支出',
  'acc102.MANUAL': '手工',
  'acc102.INVOICE': '发票',
  'acc102.SALARY': '工资',
  'acc102.DRAFT': '待补全',
  'acc102.CONFIRMED': '已登记',
  'acc102.VOID': '已作废',
  'acc102.add': '新增手工项目',
  'acc102.edit': '编辑',
  'acc102.save': '保存',
  'acc102.cancel': '取消',
  'acc102.confirm': '确认',
  'acc102.void': '作废',
  'acc102.confirmPrompt': '确认为实际收支吗？',
  'acc102.voidPrompt': '作废此记录吗？将不再计入汇总。',
  'acc102.completeFirst': '请先保存实际日期和金额。',
  'acc102.confirmedEdit': '编辑已确认记录会立即更新实际收支汇总。',
  'acc102.direction': '收支方向',
  'acc102.title': '名称',
  'acc102.targetMonth': '记录显示月份',
  'acc102.sourceMonth': '工资所属月份',
  'acc102.cashDate': '实际日期',
  'acc102.amount': '实际金额',
  'acc102.remarks': '备注',
  'acc102.status': '状态',
  'acc102.actions': '操作',
  'acc102.baseSalary': '基本工资（参考）',
  'acc102.allowance': '特别津贴（参考）',
  'acc102.missingReference': '工资资料待确认，参考金额不会套入实际金额。',
  'acc102.required': '请填写必填项。',
  'acc102.invalid': '请检查输入。金额为1至9,999,999,999,999的整数，日期不得晚于日本今天。',
  'acc102.empty': '没有匹配的记录。',
  'acc102.emptyINCOME': '当前条件下暂无收入记录',
  'acc102.emptyINCOMEHint':
    '发票一览不含税金额（含未开票预计）按所属月份自动计入；其他收入可手工登记。',
  'acc102.emptyEXPENSE': '当前条件下暂无支出记录',
  'acc102.emptyEXPENSEHint':
    '工资公司总成本和全部通勤费申请按所属月份自动计入；其他支出可手工登记。',
  'acc102.sourceNotice':
    '现有发票、工资参考不会自动计入实收实付。选择来源或手工登记，填完整实际日期、金额后保存即计入统计，无需另行确认。',
  'acc102.saveNotice':
    '保存后立即计入实际收支统计；发票收款会同步更新入金状态，请核对实际日期和金额。',
  'acc102.saved': '操作成功。',
  'acc102.receipts': '收款明细',
  'acc102.addReceipt': '新增收款',
  'acc102.invoice': '发票编号',
  'acc102.company': '公司名称',
  'acc102.invoiceAmount': '发票含税金额',
  'acc102.received': '已登记收款',
  'acc102.remaining': '未收余额',
  'acc102.billingMonth': '账单月份',
  'acc102.reload': '重新加载',
  'acc102.invoiceSources': '从发票选择',
  'acc102.history': '包含历史已收发票',
  'acc102.legacyNotice':
    '首次保存实际收款前保留旧收款状态；保存后由新账本接管，后续作废也不会恢复旧标记。',
  'acc102.salaryImport': '导入工资',
  'acc102.import': '导入',
  'acc102.batchDate': '批量设置支付日期',
  'acc102.salaryNotice':
    '导入仅建立工资参考，实际金额和日期为空，不计统计。逐人补齐实际日期、金额后保存即统计；重复导入不覆盖已有记录。',
  'acc102.batchNotice':
    '只更新当前查询结果中该所属月待补全记录的日期，不计入统计；补齐金额后逐人保存。不更改已登记、作废记录或实际金额。',
  'acc102.cashNotice':
    '实际日期、金额填完整后保存即统计，待补全记录不计合计。本页不替代概算或正式财务报表。',
  'acc102.month': '月度',
  'acc102.year': '年度',
  'acc102.allStatuses': '全部状态',
  'acc102.selectedTotal': '所选月份收支',
  'acc102.annualTotal': '年度收支',
  'acc102.balance': '差额',
  'acc102.pending': '需核对数',
  'acc102.companyCost': '公司总成本',
  'acc102.companyCostNotice':
    '工资按所属月份引用会社総コスト，含公司保险见込和零收入10万规则；发票和交通费也按所属月份统计，仅手工项目按实际日期。请勿重复登记已含的公司负担。',
  'acc102.automaticCost': '自动计入',
  'acc102.costReview': '成本待核对',
  'acc102.costBasis': '计算依据',
  'acc102.fixedCost': '零案件收入固定10万',
  'acc102.standardCost': '标准成本',
  'acc102.accountId': '员工ID',
  'acc102.employee': '员工姓名',
  'acc102.employees': '人',
  'acc102.monthDetails': '12个月明细',
  'acc102.unpaid': '未收款',
  'acc102.partial': '部分收款',
  'acc102.paid': '已收款',
  'acc102.error.ACC102_INVALID': '输入无效，请检查金额、日期和目标月份。',
  'acc102.error.ACC102_NOT_FOUND': '未找到记录，请保留输入后重新加载。',
  'acc102.error.ACC102_CONFLICT': '记录或请求存在冲突，请保留输入并重新加载最新记录。',
  'acc102.error.ACC102_OVERPAYMENT': '累计确认收款超过发票含税金额，请检查未收余额。',
  'acc102.error.ACC102_SOURCE_CHANGED': '来源数据已改变，请保留输入并重新核对来源。',
  'acc102.error.ACC102_LEGACY_DISABLED': '旧收款更新已停用，请刷新后使用收款明细。',
  'acc102.error.forbidden': '没有执行此操作的权限。',
  'acc102.error.unauthorized': '登录已过期，请重新登录。',
  'acc102.error.failed': '加载或操作失败，输入已保留，请检查网络后重试。',
};
